module.exports = __webpack_public_path__ + "img/main_bt_anipang3.b1fcd24e.png";